import React, { useEffect, useState } from 'react'
import './RecommendedClub.css'
import RCard from './RCard'
import recomended1 from '../image/club/recomended1.jpg';
import recomended2 from '../image/club/recomended2.jpg';
import recomended3 from '../image/club/recomended3.jpg';
import recomended4 from '../image/club/recomended4.jpg';
import { API_BASE_URL } from '../../utils';
import { Link } from 'react-router-dom';



const rcardData = [
    {
        id: 1,
        name: "38 Barracks",
        location: "M - Block, Connaug New Delhi",
        distance: "8.5 Km",
        rating: 4.5,
        image: recomended1
    },
    {
        id: 2,
        name: "Social Hauz",
        location: "Sector 29, Gurgaon",
        distance: "12.3 Km",
        rating: 4.2,
        image: recomended2
    },
    {
        id: 3,
        name: "The Junkyard Cafe",
        location: "Saket, South Delhi",
        distance: "5.1 Km",
        rating: 4.7,
        image: recomended3
    },
    {
        id: 4,
        name: "The Social",
        location: "Sector 29, Gurgaon",
        distance: "12.3 Km",
        rating: 4.2,
        image: recomended4
    },
];

const url = `${API_BASE_URL}/master/assets/uploads/`;

export default function RecommendedClub({ recomendedClubData }) {


    function generateClubUrl(clubName, cityName, areaName) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "_").toLowerCase() : "");

        return `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;
    }

    return (
        <div>
            <div className='vcdp-recommended-club'>
                <div className="vcdp-container">
                    <div className='vcdp-recommended-club-content'>
                        <div className="vcdp-nav-recommended">
                            <h3>Recommended Club</h3>
                            <h>See All</h>
                        </div>
                    </div>
                </div>
                <div className='vcdp-rcard-container'>
                    <div className='vcdp-rcard-wrapper'>
                        {recomendedClubData.map((item, index) => (
                            <Link to={generateClubUrl(item.name, item.cityName, item.areaName)}
                                key={index}>
                                <RCard
                                    key={item.id}
                                    name={item?.name}
                                    location={item?.address}
                                    distance={item?.distance}
                                    rating={item?.rating || '4'}
                                    image={url + item?.profile_pic}
                                />
                            </Link>
                        ))}
                    </div>
                </div>
            </div>

        </div>
    )
}
